'use strict';

const { captureMessage } = require('../analytics/sentry');
const simpleTooltip = require('../helpers/simpleTooltip');

function loadMoreReports () {
  const REPORT_PAGE_SIZE = 15;

  var reportsPerCall = REPORT_PAGE_SIZE + 1;
  var nextStep = REPORT_PAGE_SIZE;

  $('.js-next-reports-loader').on('click', function (event) {
    event.preventDefault();
    var $showMoreButton = $(this);
    var $showMoreContainer = $showMoreButton.parent('div');

    if (!$showMoreButton.hasClass('busy')) {
      $showMoreButton.addClass('busy');

      $.ajax({
        type: 'GET',
        data: 'strt=' + nextStep + '&nbr=' + reportsPerCall,
        cache: false,
        url: './ajaxreports',
        dataType: 'html',
        success: function (html) {
          nextStep += REPORT_PAGE_SIZE;
          var $newItems = $(html);
          var $moreToShow = $newItems.find('div.score-area').data('moreToShow');
          var $reportsList = $('#reports .reports-list-body');

          $reportsList.append($newItems);

          if (!$moreToShow) {
            $showMoreContainer.addClass('hidden');
          }

          $showMoreButton.removeClass('busy');
          $('body').formatTime();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          captureMessage('Overview load more report error', {
            extra: {
              textStatus: textStatus,
              errorThrown: errorThrown,
              nextStep: nextStep,
              reportsPerCall: reportsPerCall
            }
          });

          return $('#generic-error-modal').modal('show');
        }
      })
        .then(function () {
          simpleTooltip();
        });
    }
  });
}

module.exports = loadMoreReports;
